/**
	 * @summary     semantics
	 * @description Simple string compiler for creating semantic templates
 * @version     1.4.7
	 	> x-1.0 Basic array iteration and simple truthy/falsy statements
	 	> 1.1 Added support for diverse conditional statements that go beyond simple truthy/falsy statements
			- Added private variable ".__i" inside a loop's context for getting the current iteration's index
		> 1.2 Added support for traversing up the object tree via the ".__parent" property when in a loop
			- Fix for nested loops to not always point to the top level object but to each loops context is the item's object
			- Added support for modulus and division in if statements
			- Added support for helper methods to format or extend variables
		> 1.3 Bug fixes that were related to improper use of RegEx when normal substr replacement would do
		> 1.3.1 Added "keepOriginal" argument (Boolean) to the assign() function.
				When true, it will return the original dynamic string if no matching parameter was founding in the compiling data.
				i.e. "{name}".assign({age:25},{},true) >> returns "{name}" as opposed to an empty string without the "true" parameter
		> 1.3.2 Bug fixes to if statements when the right hand side of expression was dynamic with multiple tree lookups
		> 1.3.3 Bug fixes for simple truthy/falsey statements that are multiple lookup (i.e. {if:someObj.someAttr})
		> 1.3.4 Bug fixes for nested if/else statements that caused the else statement to render inappropriately in most cases
	> 1.3.5 Added indexOf support in if statements (i.e. {if:someArray indexOf someVal}YES{else}NO{/if})
	> 1.3.6 Added notIndexOf support in if statements
	> 1.3.7 Added in/notIn for support on if statements (i.e. {if:someVal in [1,2,3]}YES{else}NO{/if})
	> 1.4.0 Added support for math equations (i.e. {var * 5 + someOthervar})
	> 1.4.1 Bug fixes to if statement parsing with statements
	> 1.4.2 Wrapped helper method execution in try catch so it doesn't break a whole process
	> 1.4.3 Added support for self iteration when certain variables (i.e. {var.{otherVar}}) are nested and not compiled appropriately
	> 1.4.4 Bug fixes for some variable names that have dashes and the parser mistaking it as a math equation
	> 1.4.5 Added options parameter (Object) to compile. These options will primarily be used to modify the behaviour of compile.
		- Compile will no longer auto-evaluate values passed within the object parameter. Added setting to options to enable this. -ij
	> 1.4.6 Fixed some bugs around deep search on assign() and how the doIf() method was not working properly with parsing certain truthy/falsely statements (i.e. {if:variable} < was always false)
	> 1.4.7 Added support for FORMATTERS in .assign() method
	 * @file        semantic.js
	 * @author      Silas Garrison (http://silasgarrison.com/)
	 *
	 * This source file is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
	 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
	 *
	 ** Examples:
	 	// Some object
	 	var obj = {
			id:"Global",
			name:"Something",
			foo:[
				{id:"1",name:"Desert"},
				{id:"2",name:"Oasis"},
				{id:"3",name:"",address:"Middle of nowhere"},
				{id:"4",name:""}
			],
			prez:[
				{id:"8",name:"Las Vegas"},
				{id:"9",name:"Nevada"}
			],
			baz:[
				{prop:"Helper",space:""},
				{prop:"Invoice",space:"Zero"},
				{prop:"Shopper",space:"Free"}
			]
		};

		// Uncompiled source string
		var str = ["<div id=\"{id}\">"];
			str.push("\n");
			str.push("{if:name}{name}{else}No name{/if}, Welcome!");
			str.push("{[prez]}");
			str.push("Below is the {id} record for {name} you:");
			str.push("\n");
			str.push("{[__parent.baz]}\n{prop} is not a {if:space}<strong>{space}</strong>{else}___{/if}<br />{[/__parent.baz]}");
			str.push("{[/prez]}");
			str.push("<ul>");
			str.push("{[foo]}");
			str.push("\n<li id=\"{id}\">");
			str.push("{if:name}");
			str.push("\n<strong>Hi {name} child of {__parent.name} {if:__parent.id == Global}who's a global guy{else}not a global guy{/if}! {if:address}You live at {address}{else}You have no address{/if}</strong>");
			str.push("{else}");
			str.push("\nNo name {if:address}you live at {address}{else}you have no address{/if}");
			str.push("{/if}");
			str.push("\nThis instance has {if:id}an ID of {id}{else}no ID{/if}.");
			str.push("\n</li>");
			str.push("{[/foo]}");
			str.push("</ul>");
			str.push("</div>");

		// Compiled string
		var compiled = str.join("").compile(obj);

		console.log(compiled);
*/

// Helper method
if(!JSON.clone){
	JSON.clone = function(obj){
		var newObj = JSON.parse(JSON.stringify(obj));

		function cloneFunctions(src,targ) {
			if (src === null || typeof src !== "object") {
				return;
			}

			for (var key in src) {
				if(src.hasOwnProperty(key) && typeof src[key] === "object"){
					cloneFunctions(src[key],targ[key]);
	}
				else if(src.hasOwnProperty(key) && typeof src[key] === "function"){
					targ[key] = src[key];
				}
			}
		}
		cloneFunctions(obj,newObj);

		return newObj;
	};
}

// Builds a compiled template off a source string and object - uses the assign method to populate strings but has built-in support for array iteration and simple if block conditionals
var debugs = {};
String.prototype.compile = function(oObj, _options){
		"use strict";

		if(!_options){
			_options = {};
		}

		var str,
			doLoops,
			doIf,
			i,
			len,
			o= oObj || {},
			options = {
				disableObjEval : typeof _options.disableObjEval === 'boolean'?_options.disableObjEval:true,
				keepOriginal : typeof _options.keepOriginal === 'boolean'?_options.keepOriginal:false
			},
			rgx={
				startLoop : /\{\[/,
				closeLoop : /\]\}/,
				loopName : /\{\[[A-Z0-9|_|\-|\.| |:]+\]\}/i,
				startIf : /\{if\:[A-Z0-9|_|\-|\.| |%]+[==|===|\!=|\!==|<|>|<=|>=]{0,}\[?[A-Z0-9|_|\-| |,|\.]+\]?\}|\{if\:[A-Z0-9|_|\-|\.| ]+\}/ig,
				closeIf : /\{\/if\}/
			},
			helpers = o.helpers || {};

		str = this;

		doLoops = function(str,obj){
			var rep = [];
			// Replacement callback
			var doReplace = function(key,plc,origStr){
				var arrName,arrCond,i,len,arr,itm,itr,thisItr,newStr,start=0,end=Infinity,key;
				// Get the key name
				arrName = key.replace(rgx.startLoop,"").replace(rgx.closeLoop,"");
				// Check if a limitation has been placed
				if(arrName.indexOf(":") !== -1){
					arrCond = arrName.split(":")[1].trim();
					start = arrCond.split("-").length > 1?arrCond.split("-")[0].val():start;
					end = arrCond.split("-").length > 1?arrCond.split("-")[1].val():arrCond.split("-")[0].val();
					arrName = arrName.split(":")[0].trim();
				}
				// Get the appropriate array in the object chain
				arr = obj;
				arrName.split(".").forEach(function(itm,idx){
					arr = ((arr === undefined || arr === null)?{}:arr)[itm];
					// Traverse up the object tree twice in case the object is in the parent or grandparent - sg 12/23/2014
					if(arr === undefined){
						arr = (obj.__parent || {})[itm.trim()] || ((obj.__parent || {}).__parent || {})[itm.trim()];
					}
				});
				// See if there's a valid array from the named object chain above
				// Then see if there's a helper method matching the array name (call from top level object "o")
				// Default to an empty set
				arr = arr || (helpers[arrName] && helpers[arrName](obj)) || [];
				// Get the contents of the loop
				itr = origStr.substr(plc).split(key)[1].split("{[/" + arrName + "]}")[0];
				newStr = [];
				// Compile each iteration - can be an actual array or named array (hash map)
				if(!Array.isArray(arr)){
					i = 0;
					for(key in arr){
						if(arr.hasOwnProperty(key)){
							itm = typeof arr[key] === "object"?arr[key]:{item:arr[key]};
							thisItr = itr;

							// Put private pointer to loop iteration sequence
							if(!itm.__parent){
								var itm = JSON.clone(itm);
								itm.__key = key;
								itm.__i = i;
								itm.__parent = obj;
							}
							// If this iteration (contents of the loop) contains another loop, compile it now
							if(thisItr.indexOf("{[") !== -1 && thisItr.indexOf("]}") > thisItr.indexOf("{[")){
								thisItr = doLoops(thisItr,itm);
							}

							// Parse Ifs and output content for this string
							newStr.push(doIf(thisItr,itm).assign(itm,helpers,options));
							++i;
						}
					}
				}
				else{
					for(i=start,len=Math.min(arr.length,end); i < len;i++){
						itm = typeof arr[i] === "object"?arr[i]:{item:arr[i]};
						thisItr = itr;

						// Put private pointer to loop iteration sequence
						if(itm && !itm.__parent){
							var itm = JSON.clone(itm);
							itm.__i = i;
							itm.__parent = obj;
						// If this iteration (contents of the loop) contains another loop, compile it now
						if(thisItr.indexOf("{[") !== -1 && thisItr.indexOf("]}") > thisItr.indexOf("{[")){
							thisItr = doLoops(thisItr,itm);
						}

						// Parse Ifs and output content for this string
						newStr.push(doIf(thisItr,itm).assign(itm,helpers,options));
					}
				}
				}
				// Add a key/value pair for each source string and it's compiled replacement
				rep.push({thisStr:key + itr + "{[/" + arrName + "]}",thatStr:newStr.join("")});
				// Simply return the value the regex found - actual string rebuilding is done below
				return key;
			};

			str.replace(rgx.loopName,doReplace);

			// If the replacement array contains values, iterate over it and call the regex again until it's empty
			var sanity = 200;
			while(rep.length > 0 && sanity > 0){
				sanity--;
				rep.forEach(function(itm,idx){
					// NOTE: javascript replace treats $& as a special back reference, so you have to escape this
					itm.thatStr = itm.thatStr.split( '$&' ).join( '$$&' );
					// Replace template/HTML source with the compiled version
					str = str.replace(itm.thisStr,itm.thatStr);
				});
				// Clear out the replacements
				rep = [];
				str = str.replace(rgx.loopName,doReplace);
			}
			if( sanity == 0 ) {
				console.log( 'infinite loop ended' );
				console.log( str );
				str = 'Error compiling string';
			}
			return str;
		};

		// Logical if computation
		doIf = function(str,obj){
			var finalStr = str;
			var fnParseIf = function(str){
			var opts = ["===","==","!==","!=","<=",">=","<",">"," in "," notIn "," indexOf "," notIndexOf "],
					results = null,
					prop = null,
					val = null,
					i = 0,
					cmds = {
					exec : function(cmd){
						// Handle if statements with modulus or division
						var opr = ["%","/","*","+","-"],
							oprExc = {
								"%" : function(a,b){
									return a.val() % b.val();
								},
								"/" : function(a,b){
									return a.val() / b.val();
								},
								"*" : function(a,b){
									return a.val() * b.val();
								},
								"+" : function(a,b){
									return a.val() + b.val();
								},
								"-" : function(a,b){
									return a.val() - b.val();
								}
							},
								expr = str.split(cmd)[0].trim(),
								rawVal = str.split(cmd)[1].trim();
						// Loop through each possible operator allowed and parse the property if found
						opr.forEach(function(itm,idx){
							if(expr.indexOf(itm) !== -1){
								prop = oprExc[itm](["{",expr.split(itm)[0],"}"].join("").assign(obj,helpers,options),expr.split(itm)[1]);
							}
						});
						// If the property wasn't rendered above (no operators) parse it now
						prop = prop === null?["{",expr,"}"].join("").assign(obj,helpers,options):prop;
						if(!isNaN(parseFloat(rawVal))) {
							val = parseFloat(rawVal);
						}
						else {
							val = ["{",rawVal,"}"].join("").assign(obj,helpers,options);
								// Make sure val is a compiled value
								val = val === ""?rawVal:val;
						}

						/*
							NOTE:
								Convert "arrays" to lists so it can use indexOf
						*/
						if(rawVal.substr(0,1) === "[" && rawVal.substr(rawVal.length - 1,1) === "]"){
							val = rawVal.substr(1);
							val = val.substr(0,val.length - 1);
							val = val.split(",");
						}

						return this[cmd]();
					},
					"===" : function(){
						return prop === val;
					},
					"==" : function(){
						return prop == val;
					},
					"!==" : function(){
						return prop !== val;
					},
					"!=" : function(){
						return prop != val;
					},
					"<=" : function(){
						try {
							return prop.val() <= val.val();
						}
						catch(e){
							return prop <= val;
						}
					},
					"=>" : function(){
						try {
							return prop.val() >= val.val();
						}
						catch(e){
							return prop >= val;
						}
					},
					">=" : function(){
						try {
							return prop.val() >= val.val();
						}
						catch(e){
							return prop >= val;
						}
					},
					"<" : function(){
						try {
							return prop.val() < val.val();
						}
						catch(e){
							return prop < val;
						}
					},
					">" : function(){
						try {
							return prop.val() > val.val();
						}
						catch(e){
							return prop > val;
						}
					},
					" indexOf " : function(){
						return (prop === undefined?"":prop).toString().indexOf(val) !== -1;
					},
					" notIndexOf " : function(){
						return (prop === undefined?"":prop).toString().indexOf(val) === -1;
					},
					" in " : function(){
						return val.indexOf(prop === undefined?"":prop) !== -1;
					},
					" notIn " : function(){
						return val.indexOf(prop === undefined?"":prop) === -1;
					}
				};

				for(i = 0;i < opts.length;i++){
					if(str.indexOf(opts[i]) !== -1){
						results = cmds.exec(opts[i]);
						break;
					}
				}

				if(results === null){
					/*
						NOTE:
							Pass in the skip deep search so it doesn't try to find the variable(s) on the parent/grandparent
						TODO:
							Consider skipping out on deep search altogether...not sure it makes sense anymore
					*/
					results = ('{' + str + '}').assign(
						obj,
						helpers,
						{
							skipDeepSearch : true
						}
					);
					/*
						NOTE:
							If the result was originally boolean, it's rendered to string which means it'll convert to true
					*/
					if(results === 'false'){
						results = false;
					}

					return !!results;
				}
				else {
					return results;
				}
			};
			var lastIndex = str.indexOf("{if:");

			if(lastIndex !== -1){
				// Find all instances of {if:condition}
				str = str.replace(rgx.startIf,function(key,plc,str){
					var stm,res,itr,optA,optB,i,arr,open,closed,exCnt=0,replacer,toReplace;

					// The key is the condition (i.e. {if:name} would be name)
					stm = key.split(":")[1].split("}")[0];
					// Validate whether this condition is truthy/falsy
					res = fnParseIf(stm);
					// Get the parts of this if block
					arr = str.substr(plc).split(key)[1].split("{/if}");
					// These counters keep track of which if statement is open/closed and iteration counter
					i = 0;
					open = 1;
					closed = 0;
					itr = [];

					while(i < arr.length){
						closed += 1;
						// If we haven't closed this if body, add the string to the if body
						if(open >= closed){
							itr.push(arr[i]);
						}
						else {
							break;
						}
						open += arr[i].split("{if:").length - 1;

						++i;
					}

					itr = itr.join("{/if}");

					// Now determine else statements
					arr = itr.split("{else}");

					// If there's more than one else (meaning other if statements are in the body of this if)
					if(arr.length > 2){
						open=0;
						closed=0;
						optA = "";
						optB = "";

						i=0;
						// Loop through body parts and determine if the string goes to optA (true part of statement) or optB (false/else part of statement)
						while(i < arr.length){
							// If all the other if bodies are closed put this else under optB
							if((open === closed && i > 0) || optB !== ""){
								optB += arr[i] + "{else}";
							}
							else {
								optA += arr[i] + "{else}";
							}

							open += arr[i].split("{if:").length - 1;
							closed += arr[i].split("{/if}").length - 1;

							++i;
						}
						// Cleanup strings
						optA = optA.substr(0,optA.length - 6);
						optB = optB.substr(0,optB.length - 6);
					}
					else {
						// If there's only one else in the body of the if (its own)
					optA = arr[0] !== undefined?arr[0]:"";
					optB = arr[1] !== undefined?arr[1]:"";
					}
					// Now replace the conditional statement with the result (i.e. {if:name}Hello, {name}{else}No name found{/if} >> No name found)
					replacer = (res?optA:optB).trim();
					// Strip any unparsed/invalid statements
					if(replacer.substr(replacer.length-5) === "{/if}" && replacer.indexOf("{if:}") === -1){
						replacer = replacer.substr(0,replacer.length - 5);
					}
					// Build back what the original string was and add closing if since it get stripped
					toReplace = [key,itr,"{/if}"].join("");

					finalStr = finalStr.replace(toReplace,replacer);

					// Parse any other if blocks - make sure the last if block isn't this one (aka, bad syntax)
					while(finalStr.indexOf("{if:") !== -1 && finalStr.indexOf("{if:") !== lastIndex){
						lastIndex = finalStr.indexOf("{if:");
						finalStr = doIf(finalStr,obj);
					}

					return key;
				});
			}

			// Strip any extraneous if block closers
			return finalStr.replace(rgx.closeIf,"");
		};

		// Parse any if blocks on the main string and parse output
		var compiledTemplate = doIf(doLoops(str,o),o).assign(o,helpers,options),
			N_MAX_ATTEMPTS = 5;

		if(o.___attempts === undefined){
			o.___attempts = 1;
		}
		else {
			++o.___attempts;
		}

		if(o.___attempts < N_MAX_ATTEMPTS && compiledTemplate.indexOf('{') !== -1 && compiledTemplate.indexOf('}') !== -1){
			compiledTemplate = compiledTemplate.compile(o);
		}

		if(options.disableObjEval && compiledTemplate.indexOf('!__') !== -1 && compiledTemplate.indexOf('__!') !== -1) {
			compiledTemplate = compiledTemplate.replace(/!__/ig,'{').replace(/__!/ig,'}');
		}

		return compiledTemplate;
};

/*
	NOTE:
		Store these global pointers to help with performance.  Afte profiling the scripts in Chrome, the moment/numeral library checks were suffocating things
		- sg 11/18/2019
*/
GLOBAL_LIBRARIES_FOR_COMPILER = {
	moment : null,
	numeral : null
};
// Simple assignment function for outputting object variables in a string (i.e. Hello, {name} >> assign({name:"Silas"}) >> Hello, Silas)
String.prototype.assign = function (o,helpers,_options,keepOriginal,skipMath){
		"use strict";

		if(!o){
			o = {};
		}
		if(!_options){
			_options = _options || {};
		}

		/*
			NOTE:
				As this is used in different environments, figure out where the global libraries live
				- sg 10/31/2019
		*/
		var momentJS,
			numeralJS;

		if(GLOBAL_LIBRARIES_FOR_COMPILER.moment === null){
			try {
				app.moment();
				momentJS = app.moment;
				GLOBAL_LIBRARIES_FOR_COMPILER.moment = app.moment;
			}
			catch(e){
				try {
					moment();
					momentJS = moment;
					GLOBAL_LIBRARIES_FOR_COMPILER.moment = moment;
				}
				catch(e){
					momentJS = function(){return {};};
				}
			}
		}
		else {
			momentJS = GLOBAL_LIBRARIES_FOR_COMPILER.moment;
		}

		if(GLOBAL_LIBRARIES_FOR_COMPILER.numeral === null){
			try {
				app.numeral();
				numeralJS = app.numeral;
				GLOBAL_LIBRARIES_FOR_COMPILER.numeral = app.numeral;
			}
			catch(e){
				try {
					numeral();
					numeralJS = numeral;
					GLOBAL_LIBRARIES_FOR_COMPILER.numeral = numeral;
				}
				catch(e){
					numeralJS = function(){return {};};
				}
			}
		}
		else {
			numeralJS = GLOBAL_LIBRARIES_FOR_COMPILER.numeral;
		}

		var str = this;
		str = str.replace(
			/\{[A-Za-z0-9|_|\.| |\+|\-|\*|\/]+\}/ig,
			function(a){
					var value = a.replace(/\{/,"").replace(/\}/,"").split("."),
					/*
						NOTE:
							Added skipDeepSearch parameter so it doesn't try to find the variable(s) on the parent/grandparent
						TODO:
							Consider skipping out on deep search altogether...not sure it makes sense anymore
					*/
					options = {
						disableObjEval : typeof _options.disableObjEval === 'boolean'?_options.disableObjEval : true,
						skipDeepSearch : typeof _options.skipDeepSearch === 'boolean'?_options.skipDeepSearch : false,
						keepOriginal : typeof _options.keepOriginal === 'boolean'?_options.keepOriginal : false
					},
					retVal,
					expr = ["+","-","/","*"],
					isEquation = false,
					mathParts = [],
					doParse = true,
					formatter = null,
					formatterMask = null,
					formatters = {
						DATETIME : function(str, mask){
							try {
								// parsing UTC options from mask
								mask = typeof mask === "string"? mask:"";
								const maskOptions = mask.split(":");
								const isUTC = maskOptions[1] && maskOptions[1].includes("UTC");
								mask = maskOptions[0];

								var mom = isUTC?momentJS.utc(str):momentJS(str);

								/*
									NOTE:
										Account for possibility of just a time stamp being passed in
								*/
								if(!mom.isValid() && str.val() > new Date('01/01/1970').getTime()){
									mom = isUTC?momentJS.utc(new Date(str.val())):momentJS(new Date(str.val()));
								}
								else if(!mom.isValid()){
									mom = isUTC?momentJS.utc('01/01/1900 ' + str):momentJS('01/01/1900 ' + str);
								}

								if(mom.isValid() && str){
									/*
										NOTE:
											TOTAL_MINUTES is the duration of minutes since midnight...more formatters like this to come to make calculations easy
											- sg 06/24/2019
									*/
									if(mask === 'TOTAL_MINUTES'){
										return momentJS.duration(
											mom.diff(
												momentJS(mom.format('MM/DD/YYYY'))
											)
										).asMinutes();
									}
									else {
										return mom.format(mask);
									}
								}
								else {
									return str;
								}
							}
							catch(e){
								return str;
							}
						},
						ARRAY2STRING : function(str, mask){
							if(str.indexOf('[') !== -1 && str.indexOf(']') !== -1){
								try {
									return JSON.parse(str.trim()).join(', ').trim();
								}
								catch(e){}
							}

							return str;
						},
						NUMBER : function(str, mask){
							try {
								return numeralJS(str.toString()).format(mask);
							}
							catch(e){
								return str;
							}
						},
						PHONE : function(str, mask){
							var digits = str.toString().replace(/\D/ig,'').split(''),
								result = '';

							digits.forEach(
								function(dig, idx){
									if(idx === 0 && digits.length > 7){
										result += '(';
									}
									else if(idx === 3 && digits.length > 7){
										result += ') ';
									}
									else if(idx === 10 && digits.length > 10){
										result += ' ext. ';
									}
									else if((idx === 6 && digits.length > 7) || (idx === 3 && digits.length <= 7)){
										result += '-';
									}
									result += dig.toString();
								}
							);

							return result;
						}
					},
					/*
						NOTE:
							Implement static values that we can extend in the future
							- sg 10/31/2019
					*/
					staticValues = {
						'TODAY' : function(){
							return momentJS().format('MM/DD/YYYY hh:mm A');
						},
						'NOW' : function(){
							return momentJS().format('MM/DD/YYYY hh:mm A');
						}
					},
					formatterMasks = {
						'DATE_US' : 'MM/DD/YYYY',
						'DATE_DEFAULT' : 'MM/DD/YYYY',
						'DATE_WRITTEN' : 'MMMM D, YYYY',
						'TIME_US' : 'hh:mm A',
						'TIME_DEFAULT' : 'hh:mm A',
						'TIME_TOTAL_MINUTES' : 'TOTAL_MINUTES',
						'DATETIME_US' : 'MM/DD/YYYY hh:mm A',
						'DATETIME_DEFAULT' : 'MM/DD/YYYY hh:mm A',
                        'DATE_DEFAULTUTC' : 'MM/DD/YYYY:UTC',
						'DATE_WRITTENUTC' : 'MMMM D, YYYY:UTC',
						'TIME_DEFAULTUTC' : 'hh:mm AA:UTC',
						'DATETIME_DEFAULTUTC' : 'MM/DD/YYYY hh:mm A:UTC',
						'CURRENCY_US' : '$0,0.00',
						'CURRENCY_DEFAULT' : '$0,0.00',
						'NUMBER_DECIMALS' : '0,0.00',
						'NUMBER_DEFAULT' : '0,0',
						'NUMBER_RAW_DECIMALS_1' : '0.0',
						'NUMBER_RAW_DECIMALS_2' : '0.00',
						'NUMBER_RAW_DECIMALS_3' : '0.000',
						'NUMBER_RAW_DECIMALS_4' : '0.0000',
						'NUMBER_RAW_DECIMALS_5' : '0.00000',
						'NUMBER_RAW_DECIMALS_6' : '0.000000',
						'NUMBER_RAW_DECIMALS_7' : '0.0000000',
						'NUMBER_RAW_DECIMALS_8' : '0.00000000',
						'NUMBER_RAW' : '0'
					};

				/*
					NOTE:
						Format types actually share the same renderer (for now).  Just copy them over to new namespaces
				*/
				formatters.CURRENCY = formatters.NUMBER;
				formatters.DATE = formatters.TIME = formatters.DATETIME;

				/*
					NOTE:
						Allow for formatting to be passed in as dot notation (i.e. {FORMATTERS.DATE.dateField} or with a mask {FORMATTERS.DATE_UK.dateField})
				*/
				if(value[0] === 'FORMATTERS' && value.length > 2 && formatters[value[1].split('_')[0]]){
					formatter = value[1].split('_')[0];
					formatterMask = value[1].split('_').splice(1).join('_') || 'DEFAULT';
					value.splice(0,2);
				}

				if(keepOriginal === undefined){
					keepOriginal = options.keepOriginal;
				}

				if(keepOriginal === undefined){
					keepOriginal = options.keepOriginal;
				}

				if( /[\+|\-|\*|\/]+/.test(a) ){
					expr.forEach(
						function(exp){
							if(a.indexOf(exp) !== -1){
								isEquation = true;
								a = a.replace(new RegExp(exp.prepend("\\"),"ig"),"}" + exp + "{");
							}
						}
					);
				}

				if(isEquation && !skipMath){
					retVal = a.assign(o,helpers,options,true,true).replace(/\{|\}/ig,'').replace(/\!__/ig,'').replace(/\__!/ig,'');
					doParse = false;

					try {
						retVal = eval(retVal);
					}
					catch(e){
						// console.log('Error parsing equation (String.prototype.assign.isEquation)',e);
						/*
							NOTE:
								Sometimes the math equation formulation is just wrong (it's not actually a math problem).  So let's go ahead with a traditional parse
								- sg 05/15/2018
						*/
						doParse = true;
					}
				}

				if(doParse){
					retVal = o;
					value.forEach(function(itm,idx){
						var par;
						// Allow "helper" functions to be used
						retVal = (
							itm === 'helpers' && helpers ? helpers : (
								itm === 'STATIC' && staticValues ? staticValues : (retVal || {})[itm.trim()]
							)
						);

						/*
							NOTE:
								Traverse up the object tree twice in case the object is in the parent or grandparent - sg 12/23/2014
							NOTE:
								Added option to skip this...doesn't make sense really most times - sg 06/24/2018
						*/
						if(retVal === undefined && !options.skipDeepSearch){
							/* On the parent? */
							if((o.__parent || {})[itm.trim()] === undefined){
								/* On the grandparent? */
								if(((o.__parent || {}).__parent || {})[itm.trim()] === undefined){
									retVal = keepOriginal === true?a:'';
								}
								/* yes, grandparent */
								else {
									retVal = ((o.__parent || {}).__parent || {})[itm.trim()];
								}
							}
							else {
								/* yes, parent */
								retVal = (o.__parent || {})[itm.trim()];
							}
						}

						if(typeof retVal === 'string' && options.disableObjEval && retVal.indexOf('{') !== -1 && retVal.indexOf('}') !== -1) {
							retVal = retVal.replace(/\{/ig,'!__').replace(/\}/ig,'__!');
						}

						// If the returnVal is a function, execute now
						if(typeof retVal === 'function'){
							try {
								retVal = retVal(o);
							}
							catch(e){
								console.log('Error executing retVal (String.prototype.assign.helpers)',e);
							}
						}
					});
				}

				retVal = retVal === undefined || retVal === null?(keepOriginal === true?a:""):retVal;

				if(formatter !== null){
					retVal = formatters[formatter](retVal, formatterMasks[formatter + '_' + formatterMask]);
				}

				return retVal;
			}
		);
		// Really would only output complex objects during debug
		return typeof str === "object"?JSON.stringify(str):str;
};
